/* eslint-disable */
export function downloadCSV(csv,date) {
    var csvFile;
    var downloadLink;

    // CSV file
    csvFile = new Blob([csv], {
        type: "text/csv"
    });

    // Download link
    downloadLink = document.createElement("a");

    var date_string = date.toJSON().slice(0, 10);;


    // File name
    downloadLink.download = date_string+"-data.csv";//downloadFileName;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = "none";

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
}


export function degToCompass(num) {
  const cardinalDirections=['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW','N'];
  var degToIndex = Math.floor((num / 22.5) + .5)
  return cardinalDirections[degToIndex];
}



export function getMonths(){
  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var monthObjs = []

  const today = new Date();
  var monthIndex = today.getMonth()+1
  var year =  today.getFullYear();
  var i;

  for (i = 0; i < 12; i++) {
    monthIndex--;
    if (monthIndex < 0){
      monthIndex=11;
      year--;
    }
    monthObjs[i] = { 
        month:monthIndex+1,
        year:year,
        text: months[monthIndex]+" " +year
    }
  }
  return monthObjs;
}


export function transpose(A) {
  const result = [];
  try{
    for (let i = 0; i < A[0].length; i++) {
      const col = [];
      for (let j = 0; j < A.length; j++) {
        col.push(A[j][i]);
      }
      result.push(col);
    }
  }catch{
    console.log('transpose error');
  }
  return result;
}

export function getDishSensors(content) {
  let retVal = {};
  if (content.ConcentratorReadings) {
    retVal = content.ConcentratorReadings.Sensors;
  }
  return retVal;
}

export function getLoopSensors(content) {
  let retVal = {};
  if (content.LoopReadings) {
    retVal = content.LoopReadings.Sensors;
  }
  return retVal;
}

export function getWeatherSensors(content) {
  let retVal = {};
  if (content.WeatherReadings) {
    retVal = content.WeatherReadings.readings;
  }
  return retVal;
}

export function getSunlightSensors(content) {
  let retVal = {};
  if (content.DNIReadings) {
    retVal = content.ConcentratorReadings.Sensors;
  }
  return retVal;
}

export function getWeatherSensorKey(index) {
    var retVal;
    switch (index) {
        case 0:
            retVal = "Air Temp";
            break;
        case 1:
            retVal = "Solar Intensity";
            break;
        case 2:
            retVal = "Wind Speed (inst)";
            break;
        case 3:
            retVal = "Wind Speed (avg)";
            break;
        case 4:
            retVal = "Wind Speed (max)";
            break;
        case 5:
            retVal = "Wind Direction";
            break;
        case 6:
            retVal = "Humidity";
            break;
        case 7:
            retVal = "Derived DNI";
            break;
    }
    return retVal;
}

export function getWeatherSensorValue(index, weatherSensors) {
    var retVal
    switch (index) {
        case 0:
            retVal = weatherSensors['airTemp'];
            break;
        case 1:
            retVal = weatherSensors['solarIntensity'];
            break;
        case 2:
            retVal = weatherSensors['windSpd'];
            break;
        case 3:
            retVal = weatherSensors['windSpdAvg'];
            break;
        case 4:
            retVal = weatherSensors['windSpeedMax'];
            break;
        case 5:
            retVal = weatherSensors['windDir'];
            break;
        case 6:
            retVal = weatherSensors['hmdty'];
            break;
        case 7:
            retVal = weatherSensors['derivedDNI'];
            break;
    }
    return retVal;
}

export function getDeviceIdFromURL(url){
  let urlParts = url.split('/');
 return urlParts[6];
}

export function getSiteIdFromURL(url){
  let urlParts = url.split('/');
  return urlParts[4];
}

export function getSiteWithId(siteId, fleetInfo){
  let returnValue = null;
   fleetInfo.sites.forEach(site => {
    if(site.siteId === siteId){
      returnValue = site;
    }
  });
   return returnValue;
}

export function getDeviceWithId(deviceId, site){
  let returnValue = null;
  site.concentrators.forEach(concentrator => {
    if(concentrator.deviceId === deviceId){
      returnValue = concentrator;
    }
  });
  if(returnValue === null){
    site.secondaryLoops.forEach(secondaryLoop => {
      if(secondaryLoop.deviceId === deviceId){
        returnValue = secondaryLoop;
      }
    });
  }
  if(returnValue === null){
    site.weatherStations.forEach(weatherStation => {
      if(weatherStation.deviceId === deviceId){
        returnValue = weatherStation;
      }
    });
  }
   return returnValue;
}